// @ts-nocheck
import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { setRoutes } from '@utils/routesHelper';
import LoggedLayout from '@components/layout/LoggedLayout';
import { ErrorBoundary, SentryErrorBoundaryHandle } from '@agilize/components-core';
import ErrorPage from '@pages/errorPage/ErrorPage';
import { useLeadContext } from '@context/LeadContext';
import LeadNotFound from '@pages/LeadNotFound/LeadNotFound';
import SelectProgress from '@pages/SelectProcess/SelectProgress';
import { routes } from './routes';

export const history = createBrowserHistory();

const NotFoundPage = lazy(() => import('@pages/404/NotFoundPage'));
const Phases = lazy(() => import('@pages/phases/Phases'));
const Welcome = lazy(() => import('@pages/WelcomePage/WelcomePage'));
const FinishPage = lazy(() => import('@pages/FinishPage/FinishPage'));

const PrivateRouting = () => {
  const { leads, lead, isFetchingLead } = useLeadContext();

  useEffect(() => {
    setRoutes(routes);
  }, []);

  if (isFetchingLead) {
    return null;
  }

  const HomeRoute = () => {
    if (!lead && leads.length > 1) {
      return <Route path="/" component={SelectProgress} />;
    }

    if (!lead) {
      return <Route path="/" component={LeadNotFound} />;
    }

    if (lead.onboardingFinished || lead.onboardingScreened) {
      return <Route path="/" component={FinishPage} />;
    }

    if (lead.onboardingInitialized) {
      return <Route path="/" component={Phases} />;
    }

    return <Route path="/" component={Welcome} />;
  };

  return (
    <BrowserRouter>
      <ErrorBoundary onError={SentryErrorBoundaryHandle} callbackComponent={<ErrorPage />}>
        <LoggedLayout>
          <Suspense fallback={<></>}>
            <Switch>
              <HomeRoute />
              <Route path="*" component={NotFoundPage} />
            </Switch>
          </Suspense>
        </LoggedLayout>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default PrivateRouting;
